import { render, staticRenderFns } from "./basicInfoForm.vue?vue&type=template&id=665ba6a6&scoped=true"
import script from "./basicInfoForm.vue?vue&type=script&lang=js"
export * from "./basicInfoForm.vue?vue&type=script&lang=js"
import style0 from "./basicInfoForm.vue?vue&type=style&index=0&id=665ba6a6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665ba6a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('665ba6a6')) {
      api.createRecord('665ba6a6', component.options)
    } else {
      api.reload('665ba6a6', component.options)
    }
    module.hot.accept("./basicInfoForm.vue?vue&type=template&id=665ba6a6&scoped=true", function () {
      api.rerender('665ba6a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/receivableManagementSite/aRGenerationNew/cmp/FeeDetail/basicInfoForm.vue"
export default component.exports